import { ensureEmbeddedPath } from '@opallabs/brown-dwarf'

const navigateTo =
  ({ route, options }) =>
  () => {
    const nextPath = window.embedded
      ? ensureEmbeddedPath(window, { pathname: route })
      : route
    window.OpalBase.navigate(nextPath, { trigger: true, ...options })
  }

export default navigateTo
